import { render, staticRenderFns } from "./cerrar_session.vue?vue&type=template&id=0af0e54b&scoped=true&"
import script from "./cerrar_session.vue?vue&type=script&lang=ts&"
export * from "./cerrar_session.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af0e54b",
  null
  
)

export default component.exports